import React from 'react';
import { Checkbox, CheckboxProps, Flex, Text } from '@televet/kibble-ui';

interface IMergeProfilesNoneTagProps {
  includeCheckbox?: boolean;
  checkboxProps?: CheckboxProps;
}

const MergeProfilesNoneTag = ({ includeCheckbox, checkboxProps }: IMergeProfilesNoneTagProps): JSX.Element => {
  return (
    <Flex mx={1} pt={2} gap={2} alignItems="center" justifyContent="flex-start">
      {includeCheckbox && <Checkbox isFieldInline pt={1} {...checkboxProps} />}
      <Text size="sm">{`(None)`}</Text>
    </Flex>
  );
};

export default MergeProfilesNoneTag;
